// extracted by mini-css-extract-plugin
module.exports = {"fullLoading":"fullLoading_fullLoading__37woL","message":"fullLoading_message__MtcU2"};